if (!customElements.get("m-banner-with-slide")) {
  class MBannerWithSlide extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.lastActive = null;
      this.initSlider();
    }

    initSlider() {
      const __this = this;
      const sliderElement = this.querySelector(`.m-slider-${this.dataset.id}`);
      if (!sliderElement) return;
      
      const slides = sliderElement.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      const shouldLoop = slideCount > 1;
      const paginationEl = this.querySelector(".swiper-pagination");
      
      // Esconde paginação se houver apenas 1 slide
      if (slideCount <= 1 && paginationEl) {
        paginationEl.style.display = 'none';
      }
      
      // Adiciona classe para desabilitar interações quando há apenas 1 slide
      if (slideCount <= 1) {
        sliderElement.classList.add('swiper-no-swiping');
        this.classList.add('m-banner-with-slider--single-slide');
      }
      
      this.slider = new MinimogLibs.Swiper(`.m-slider-${this.dataset.id}`, {
        autoplay:
          this.dataset.autoplay === "true" && shouldLoop ? { delay: this.dataset.timeout, disableOnInteraction: true } : false,
        slidesPerView: 1,
        loop: shouldLoop,
        allowTouchMove: shouldLoop,
        simulateTouch: shouldLoop,
        touchStartPreventDefault: !shouldLoop,
        fadeEffect: {
          crossFade: true,
        },
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: shouldLoop,
          bulletClass: "m-dot",
          bulletActiveClass: "m-dot--active",
        } : false,
        on: {
          init: function (swiper) {
            if (shouldLoop && this.lastActive !== null) {
              this.slideToLoop(this.lastActive);
            }
            __this.handleChange(swiper);
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    handleChange(swiper) {
      const currentSlide = swiper.slides[swiper.activeIndex];
      if (currentSlide) {
        const currentColor = window.getComputedStyle(currentSlide).getPropertyValue("color");
        currentColor && this.style.setProperty("--swiper-controls-color", currentColor);
      }
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        const sliderElement = this.querySelector(`.m-slider-${this.dataset.id}`);
        const slides = sliderElement ? sliderElement.querySelectorAll('.swiper-slide') : [];
        const slideCount = slides.length;
        
        if (slideCount > 1 && this.slider.params.loop) {
          this.slider.slideToLoop(index);
        } else {
          this.slider.slideTo(index);
        }
      }
    }
  }

  customElements.define("m-banner-with-slide", MBannerWithSlide);
}
